import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';

export interface InputDialogData {
  title: string;
  description?: string;
  placeholder?: string;
  initialValue?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  required?: boolean;
}

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    TranslatePipe,
  ],
  selector: 'app-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.scss'],
})
export class InputDialogComponent {
  protected readonly inputControl: FormControl<string>;

  constructor(
    public dialogReference: MatDialogRef<InputDialogComponent, string | undefined>,
    @Inject(MAT_DIALOG_DATA) public data: InputDialogData
  ) {
    const required = data.required !== false;
    this.inputControl = new FormControl<string>(data.initialValue ?? '', {
      nonNullable: true,
      validators: required ? [Validators.required] : [],
    });
  }

  public handleConfirm(): void {
    if (this.inputControl.invalid) {
      return;
    }
    this.dialogReference.close(this.inputControl.value);
  }

  public handleCancel(): void {
    this.dialogReference.close(undefined);
  }
}
